// Test IDs for the Operations platform UI.

export const OPS = {
    login: {
        identifier: "login-form-identifier-input",
        password: "login-form-password-input",
        submit: "login-form-submit-button",
        error: "login-error",
    },
    quality: {
        hub: "quality-hub",
        nav: "sidebar-nav-item-quality",
        tab: (k) => `quality-hub-tab-${k}`,
    },
    system: {
        ingestPage: "ingest-status-page",
        ingestTable: "ingest-status-table",
        sourceRow: (s) => `ingest-source-row-${s}`,
        sourceStatus: (s) => `ingest-source-status-${s}`,
        eventsTable: "ingest-events-table",
        eventRow: (id) => `ingest-event-row-${id}`,
        testEmitBtn: "ingest-test-emit-btn",
        testEmitConfirm: "ingest-test-emit-confirm",
        testEmitConfirmStart: "ingest-test-emit-confirm-start",
        metricsCard: "ingest-metrics-catalog",
        nav: "sidebar-nav-item-ingest-status",
        refresh: "ingest-status-refresh",
    },
    opsDashboard: {
        page: "ops-dashboard-page",
        refresh: "ops-dashboard-refresh",
        asOf: "ops-dashboard-asof",
        totalRow: "ops-dashboard-total-row",
        grid: "ops-dashboard-grid",
        row: (bid) => `ops-dashboard-row-${bid}`,
        tile: (bid, key) => `ops-tile-${key}-${bid}`,
        moduleTile: (bid, key) => `ops-module-tile-${key}-${bid}`,
        drill: "ops-dashboard-drill",
        nav: "sidebar-nav-item-dashboard",
        chartsSection: "ops-dashboard-charts",
        attainmentChart: "ops-attainment-chart",
        attainmentEmpty: "ops-attainment-empty",
        moversChart: "ops-movers-chart",
        moversEmpty: "ops-movers-empty",
    },
    checkin: {
        page: "branch-checkin-page",
        nav: "sidebar-nav-item-checkin",
        branchSelect: "checkin-branch-select",
        dateInput: "checkin-date-input",
        datePrev: "checkin-date-prev",
        dateNext: "checkin-date-next",
        todayBtn: "checkin-today-btn",
        openCard: "checkin-open-card",
        closeCard: "checkin-close-card",
        openNowBtn: "checkin-open-now-btn",
        closeNowBtn: "checkin-close-now-btn",
        editBtn: (k) => `checkin-edit-${k}`,
        manualInput: (k) => `checkin-manual-input-${k}`,
        manualSave: (k) => `checkin-manual-save-${k}`,
        manualCancel: (k) => `checkin-manual-cancel-${k}`,
        earlyBadge: (k) => `checkin-early-close-${k}`,
        scheduleBtn: "checkin-schedule-btn",
        scheduleDialog: "checkin-schedule-dialog",
        scheduleOpen: (d) => `checkin-schedule-open-${d}`,
        scheduleClose: (d) => `checkin-schedule-close-${d}`,
        scheduleClosed: (d) => `checkin-schedule-closed-${d}`,
        scheduleSave: "checkin-schedule-save",
        summaryMonth: "checkin-summary-month",
        summaryOpenPct: "checkin-summary-open-pct",
        summaryClosePct: "checkin-summary-close-pct",
        summaryCloseEarly: "checkin-summary-close-early",
        // Ingest Status: recompute stored closes (midnight fix)
        recomputeCard: "checkin-recompute-card",
        recomputePreview: "checkin-recompute-preview",
        recomputeApply: "checkin-recompute-apply",
        recomputeConfirm: "checkin-recompute-confirm",
        recomputeCount: (k) => `checkin-recompute-count-${k}`,
        recomputeLines: "checkin-recompute-lines",
        recomputeResult: "checkin-recompute-result",
        recomputeLast: "checkin-recompute-last",
        empty: "checkin-empty-state",
    },
    branchKpi: {
        page: "branch-kpi-page",
        nav: "sidebar-nav-item-branch-kpi",
        viewSingle: "bkpi-view-single",
        viewCompare: "bkpi-view-compare",
        branchSelect: "bkpi-branch-select",
        monthSelect: "bkpi-month-select",
        dateInput: "bkpi-date-input",
        card: (k) => `bkpi-card-${k}`,
        cardValue: (k) => `bkpi-card-value-${k}`,
        table: "bkpi-compare-table",
        colHeader: (k) => `bkpi-col-${k}`,
        row: (bid) => `bkpi-row-${bid}`,
        cell: (bid, k) => `bkpi-cell-${bid}-${k}`,
        empty: "bkpi-empty-state",
        monthGap: "bkpi-month-gap",
    },
    salesBudget: {
        page: "sales-budget-page",
        monthInput: "budget-month-input",
        refresh: "budget-refresh",
        importBtn: "budget-import-btn",
        table: "budget-table",
        row: (bid) => `budget-row-${bid}`,
        rag: (bid) => `budget-rag-${bid}`,
        setTargetBtn: (bid) => `budget-set-target-${bid}`,
        totalRow: "budget-total-row",
        coverage: "budget-coverage",
        comparedNote: "budget-compared-note",
        dialog: "budget-target-dialog",
        dialogInput: "budget-target-input",
        dialogSave: "budget-target-save",
        dialogClear: "budget-target-clear",
        importDialog: "budget-import-dialog",
        importFile: "budget-import-file",
        importUpload: "budget-import-upload",
        importResult: "budget-import-result",
        importFailed: "budget-import-failed",
    },
    shell: {
        sidebar: "app-sidebar",
        topbar: "app-topbar",
        langToggle: "language-toggle",
        userMenu: "user-menu",
        logout: "logout-button",
        mobileMenu: "mobile-menu-trigger",
        navItem: (k) => `sidebar-nav-item-${k}`,
        comingSoonBadge: "sidebar-coming-soon-badge",
        notificationsMenuItem: "user-menu-notifications",
        notifDialog: "notifications-dialog",
        notifDialogSwitch: "notifications-dialog-qc-switch",
        notifDialogSave: "notifications-dialog-save",
        notifBell: "notif-inbox-bell",
        notifBadge: "notif-inbox-badge",
        notifPanel: "notif-inbox-panel",
        notifMarkAll: "notif-inbox-mark-all",
        notifItem: (id) => `notif-item-${id}`,
    },
    sales: {
        page: "sales-page",
        hub: "sales-hub",
        hubTab: (k) => `sales-hub-tab-${k}`,
        branchFilter: "sales-branch-filter",
        periodPicker: "sales-period-picker",
        periodPreset: (k) => `sales-period-preset-${k}`,
        periodApply: "sales-period-apply",
        kpi: "sales-kpi-section",
        kpiCard: (k) => `sales-kpi-card-${k}`,
        daily: "sales-daily-section",
        dailyChart: "sales-daily-chart",
        dailyNote: "sales-daily-network-note",
        monthly: "sales-monthly-section",
        monthlyChart: "sales-monthly-chart",
        branchPerf: "sales-branch-performance-section",
        itemGapEmpty: "sales-item-gap-empty",
        scorecard: "sales-scorecard-section",
        scorecardMonth: "sales-scorecard-month",
        scorecardCompareChart: "sales-scorecard-compare-chart",
        scorecardTrendChart: "sales-scorecard-trend-chart",
        scorecardYoyChart: "sales-scorecard-yoy-chart",
        scorecardYoyEmpty: "sales-scorecard-yoy-empty",
        scorecardBranchBar: (id) => `sales-scorecard-branch-${id}`,
        scorecardTab: (k) => `sales-scorecard-tab-${k}`,
        branchRow: (id) => `sales-branch-row-${id}`,
        items: "sales-item-sales-section",
        itemRow: (id) => `sales-item-row-${id}`,
        channels: "sales-channels-section",
        channelsChart: "sales-channels-chart",
        channelMix: "sales-channel-mix-section",
        channelMixBar: "sales-channel-mix-bar",
        channelMixCard: (k) => `sales-channel-mix-card-${k}`,
        averages: "sales-averages-section",
        avgCard: (k) => `sales-avg-card-${k}`,
        emptyState: "sales-empty-state",
        importBtn: "sales-import-button",
        explorer: "sales-explorer",
        explorerGroupBy: (k) => `sales-explorer-group-${k}`,
        explorerChannelToggle: "sales-explorer-channel-toggle",
        explorerChartToggle: "sales-explorer-chart-toggle",
        explorerChart: "sales-explorer-chart",
        explorerSummary: "sales-explorer-summary",
        explorerSummaryCard: (k) => `sales-explorer-summary-${k}`,
        explorerTable: "sales-explorer-table",
        explorerRow: (id) => `sales-explorer-row-${id}`,
        explorerMixBar: "sales-explorer-mix-bar",
        explorerCompareToggle: "sales-explorer-compare-toggle",
        explorerCompareMetric: (k) => `sales-explorer-compare-metric-${k}`,
        explorerCompareChart: "sales-explorer-compare-chart",
        explorerCompareTable: "sales-explorer-compare-table",
        explorerCompareNote: "sales-explorer-compare-note",
        explorerCompareRow: (k) => `sales-explorer-compare-row-${k}`,
        explorerSummaryDelta: (k) => `sales-explorer-summary-delta-${k}`,
    },
    dsr: {
        page: "branch-dsr-page",
        branchSelect: "branch-dsr-branch-select",
        monthSelect: "branch-dsr-month-select",
        empty: "branch-dsr-empty-state",
        table: "branch-dsr-table",
        row: (iso) => `branch-dsr-row-${iso}`,
        totalsRow: "branch-dsr-totals-row",
        prevRow: "branch-dsr-prev-row",
        deltaRow: "branch-dsr-delta-row",
        coverageBadge: "branch-dsr-coverage-badge",
        expandBtn: (iso) => `branch-dsr-expand-${iso}`,
        appsRow: (iso) => `branch-dsr-apps-row-${iso}`,
        appsRowApp: (iso, app) => `branch-dsr-apps-${iso}-${app}`,
        allTable: "branch-dsr-all-table",
        allRow: (id) => `branch-dsr-all-row-${id}`,
        networkRow: "branch-dsr-network-row",
    },
    qcIns: {
        page: "qc-inspection-page",
        placeholder: "qc-inspection-placeholder",
        tab: (k) => `qc-inspection-tab-${k}`,
        adminPage: "qc-inspection-admin-page",
        addBtn: "qc-inspection-add-btn",
        emptyState: "qc-inspection-empty",
        card: (id) => `qc-inspection-section-card-${id}`,
        editBtn: (id) => `qc-inspection-edit-${id}`,
        moveUpBtn: (id) => `qc-inspection-move-up-${id}`,
        moveDownBtn: (id) => `qc-inspection-move-down-${id}`,
        toggleBtn: (id) => `qc-inspection-toggle-${id}`,
        deleteBtn: (id) => `qc-inspection-delete-${id}`,
        deleteConfirm: "qc-inspection-delete-confirm",
        deleteCancel: "qc-inspection-delete-cancel",
        form: {
            dialog: "qc-inspection-form-dialog",
            sectionKey: "qc-inspection-form-key",
            titleAr: "qc-inspection-form-title-ar",
            titleEn: "qc-inspection-form-title-en",
            subtitleAr: "qc-inspection-form-subtitle-ar",
            subtitleEn: "qc-inspection-form-subtitle-en",
            items: "qc-inspection-form-items",
            save: "qc-inspection-form-save",
            cancel: "qc-inspection-form-cancel",
        },
        responsible: {
            root: (p) => `qc-responsible-${p}`,
            chip: (p, i) => `qc-responsible-chip-${p}-${i}`,
            remove: (p, i) => `qc-responsible-remove-${p}-${i}`,
            add: (p) => `qc-responsible-add-${p}`,
            manualInput: (p) => `qc-responsible-manual-input-${p}`,
            manualAdd: (p) => `qc-responsible-manual-add-${p}`,
            hrNote: (p) => `qc-responsible-hr-note-${p}`,
            gateNote: (p) => `qc-responsible-gate-note-${p}`,
        },
        branches: {
            page: "qc-branches-page",
            row: (id) => `qc-branches-row-${id}`,
            renameBtn: (id) => `qc-branches-rename-${id}`,
            dialog: "qc-branches-rename-dialog",
            inputAr: "qc-branches-name-ar",
            inputEn: "qc-branches-name-en",
            save: "qc-branches-rename-save",
            cancel: "qc-branches-rename-cancel",
        },
        rounds: {
            startBtn: "qc-rounds-start-btn",
            draftsSection: "qc-rounds-drafts",
            submittedSection: "qc-rounds-submitted",
            card: (id) => `qc-rounds-card-${id}`,
            emailStatus: (id) => `qc-rounds-email-status-${id}`,
            startDialog: "qc-rounds-start-dialog",
            startBranchSelect: "qc-rounds-start-branch",
            startCancel: "qc-rounds-start-cancel",
            startConfirm: "qc-rounds-start-confirm",
            admin: {
                menu: (id) => `qc-round-admin-menu-${id}`,
                edit: (id) => `qc-round-admin-edit-${id}`,
                close: (id) => `qc-round-admin-close-${id}`,
                reopen: (id) => `qc-round-admin-reopen-${id}`,
                del: (id) => `qc-round-admin-delete-${id}`,
                archive: (id) => `qc-round-admin-archive-${id}`,
                unarchive: (id) => `qc-round-admin-unarchive-${id}`,
                confirmTitle: "qc-round-admin-confirm-title",
                confirmBtn: "qc-round-admin-confirm-btn",
                editVisitDate: "qc-round-admin-edit-visit-date",
                editSave: "qc-round-admin-edit-save",
            },
            showArchivedToggle: "qc-rounds-show-archived-toggle",
            archivedSection: "qc-rounds-archived",
        },
        wizard: {
            root: "qc-wizard",
            closeBtn: "qc-wizard-close",
            backBtn: "qc-wizard-back",
            nextBtn: "qc-wizard-next",
            submitBtn: "qc-wizard-submit",
            submitConfirm: "qc-wizard-submit-confirm",
            submitCancel: "qc-wizard-submit-cancel",
            progress: "qc-wizard-progress",
            savingIndicator: "qc-wizard-saving",
            sectionSubtitle: "qc-wizard-section-subtitle",
            sectionNotes: (k) => `qc-wizard-notes-${k}`,
            sectionNoteSeverity: (k) => `qc-wizard-note-severity-${k}`,
            sectionPhotos: (k) => `qc-wizard-section-photos-${k}`,
            sectionPhotoInput: (k) => `qc-wizard-section-photo-input-${k}`,
            sectionPhotoBtn: (k) => `qc-wizard-section-photo-btn-${k}`,
            sectionPhotoHint: (k) => `qc-wizard-section-photo-hint-${k}`,
            reviewSectionPhotos: (k) => `qc-wizard-review-section-photos-${k}`,
            itemRow: (k, i) => `qc-wizard-item-${k}-${i}`,
            itemCheckbox: (k, i) => `qc-wizard-item-check-${k}-${i}`,
            severitySelect: (vid) => `qc-wizard-severity-${vid}`,
            responsibleInput: (vid) => `qc-wizard-responsible-${vid}`,
            responsibleSelect: (vid) => `qc-wizard-responsible-select-${vid}`,
            responsibleHrNote: (vid) => `qc-wizard-responsible-hr-note-${vid}`,
            responsibleGateNote: (vid) => `qc-wizard-responsible-gate-note-${vid}`,
            deadlineInput: (vid) => `qc-wizard-deadline-${vid}`,
            descriptionInput: (vid) => `qc-wizard-description-${vid}`,
            photoInput: (vid) => `qc-wizard-photo-input-${vid}`,
            photoBtn: (vid) => `qc-wizard-photo-btn-${vid}`,
            photoThumb: (pid) => `qc-wizard-photo-${pid}`,
            photoDeleteBtn: (pid) => `qc-wizard-photo-delete-${pid}`,
            review: "qc-wizard-review",
            reviewViolationCard: (vid) => `qc-wizard-review-violation-${vid}`,
            reviewEditSection: (k) => `qc-wizard-review-edit-${k}`,
            reviewPhotoThumb: (pid) => `qc-wizard-review-photo-${pid}`,
            lightbox: "qc-wizard-lightbox",
            lightboxClose: "qc-wizard-lightbox-close",
            lightboxImage: "qc-wizard-lightbox-image",
        },
        violations: {
            page: "qc-violations-page",
            filterBar: "qc-violations-filter-bar",
            filterBranch: "qc-violations-filter-branch",
            filterStatus: "qc-violations-filter-status",
            filterSeverity: "qc-violations-filter-severity",
            filterSection: "qc-violations-filter-section",
            filterOverdue: "qc-violations-filter-overdue",
            clearFilters: "qc-violations-clear-filters",
            statBar: "qc-violations-stat-bar",
            row: (id) => `qc-violations-row-${id}`,
            hrPush: (id) => `qc-violations-hr-push-${id}`,
            detailDialog: "qc-violation-detail",
            detailSummary: "qc-violation-detail-summary",
            detailStatus: "qc-violation-detail-status",
            statusControls: "qc-violation-status-controls",
            setStatusBtn: (s) => `qc-violation-set-status-${s}`,
            reopenBtn: "qc-violation-reopen",
            pendingBanner: "qc-violation-pending-banner",
            submitResolutionBtn: "qc-violation-submit-resolution",
            resolutionNote: "qc-violation-resolution-note",
            approveBtn: "qc-violation-approve",
            sendBackBtn: "qc-violation-send-back",
            sendBackReason: "qc-violation-send-back-reason",
            reviewNote: "qc-violation-review-note",
            timeline: "qc-violation-timeline",
            uploadAfterBtn: "qc-violation-upload-after",
            afterPhotoInput: "qc-violation-after-photo-input",
            photoCompare: "qc-violation-photo-compare",
            photosBefore: "qc-violation-photos-before",
            photosAfter: "qc-violation-photos-after",
            readonlyBanner: "qc-violation-readonly-banner",
            closeNoProofConfirm: "qc-violation-close-noproof-confirm",
            closeNoProofCancel: "qc-violation-close-noproof-cancel",
            editBtn: "qc-violation-edit-btn",
            deleteBtn: "qc-violation-delete-btn",
            editSeverity: "qc-violation-edit-severity",
            editDescription: "qc-violation-edit-description",
            editResponsible: "qc-violation-edit-responsible",
            editResponsibleSelect: "qc-violation-edit-responsible-select",
            editDeadline: "qc-violation-edit-deadline",
            editSave: "qc-violation-edit-save",
            editCancel: "qc-violation-edit-cancel",
            deleteConfirm: "qc-violation-delete-confirm",
            deleteCancel: "qc-violation-delete-cancel",
        },
        dashboard: {
            page: "qc-dashboard",
            filterBar: "qc-dashboard-filter-bar",
            filterBranches: "qc-dashboard-filter-branches",
            filterSeverity: "qc-dashboard-filter-severity",
            filterRange: "qc-dashboard-filter-range",
            filterRangePreset: (k) => `qc-dashboard-preset-${k}`,
            kpiRounds: "qc-dashboard-kpi-rounds",
            kpiViolations: "qc-dashboard-kpi-violations",
            kpiClosedPct: "qc-dashboard-kpi-closed-pct",
            kpiOverdue: "qc-dashboard-kpi-overdue",
            kpiAvgTtc: "qc-dashboard-kpi-avg-ttc",
            trendChart: "qc-dashboard-trend",
            topBranches: "qc-dashboard-top-branches",
            topItems: "qc-dashboard-top-items",
            openVsClosed: "qc-dashboard-open-vs-closed",
            inspectorTable: "qc-dashboard-inspector-table",
            branchPerf: "qc-dashboard-branch-performance",
            branchPerfRow: (id) => `qc-dashboard-branch-performance-row-${id}`,
            empty: "qc-dashboard-empty",
        },
    },
    importer: {
        dialog: "import-dialog",
        file: "import-file-input",
        upload: "import-upload-button",
        token: "import-service-token",
        copy: "import-copy-token",
        result: "import-result",
    },
    users: {
        page: "users-page",
        table: "users-table",
        add: "users-add-button",
        search: "users-search-input",
        rowMenu: (id) => `users-row-menu-${id}`,
        edit: (id) => `users-edit-action-${id}`,
        reset: (id) => `users-reset-password-action-${id}`,
        toggle: (id) => `users-toggle-active-action-${id}`,
        del: (id) => `users-delete-action-${id}`,
        roleBadge: (id) => `users-role-badge-${id}`,
        assignedBranchLabel: (id) => `users-assigned-branch-${id}`,
        form: {
            name: "user-form-name",
            email: "user-form-email",
            nid: "user-form-national-id",
            password: "user-form-password",
            role: "user-form-role",
            notifyQc: "user-form-notify-qc",
            assignedBranch: "user-form-assigned-branch",
            save: "user-form-save",
            cancel: "user-form-cancel",
        },
        permEditor: "users-permission-editor",
        hubBranches: "user-form-hub-branches",
        hubBranchesHint: "user-form-hub-branches-hint",
        scLocations: "user-form-sc-locations",
        scLocationsHint: "user-form-sc-locations-hint",
        scLockNote: "user-form-sc-lock-note",
        capGroup: (g) => `user-form-cap-group-${g}`,
        permTabs: "permission-tabs-selector",
        permTab: (k) => `permission-tab-${k}`,
        permBranches: "permission-branches-selector",
        permSections: "permission-sections-selector",
        permMetrics: "permission-metrics-selector",
        finAccess: "permission-financials-access",
        permFinBranches: "permission-financials-branches-selector",
        permCaps: "permission-capabilities",
        permCap: (k) => `permission-cap-${k}`,
        permQcScope: "permission-qc-access",
        permQcBranches: "permission-qc-branches-selector",
        resetInput: "reset-password-input",
        resetConfirm: "reset-password-confirm",
    },
    financials: {
        page: "financials-page",
        branchFilter: "financials-branch-filter",
        emptyState: "financials-empty-state",
        dataMenu: "financials-data-menu",
        importBtn: "financials-import-button",
        reconPanel: "financials-reconciliation-panel",
        reconLine: (k) => `financials-reconcile-line-${k}`,
        partialBadge: "financials-partial-badge",
        periodPicker: "financials-period-picker",
        periodPreset: (k) => `financials-period-preset-${k}`,
        periodApply: "financials-period-apply",
        kpi: "financials-kpi-section",
        kpiCard: (k) => `financials-kpi-card-${k}`,
        ranking: "financials-branch-ranking-section",
        rankingChart: "financials-branch-ranking-chart",
        rankRow: (id) => `financials-branch-rank-row-${id}`,
        monthly: "financials-monthly-section",
        monthlyChart: "financials-monthly-chart",
        expenses: "financials-expense-section",
        expenseChart: "financials-expense-chart",
        expenseRow: (k) => `financials-expense-row-${k}`,
        monthlyDetail: "financials-monthly-detail-section",
        monthlyDetailMonth: "financials-monthly-detail-month",
        mdTable: "financials-monthly-detail-table",
        mdLineRow: (id) => `financials-md-line-${id}`,
        mdGroupRow: (k) => `financials-md-group-${k}`,
        mdNetRow: "financials-md-net-row",
        story: "financials-story",
        hero: "financials-hero",
        heroWaterfall: "financials-hero-waterfall",
        heroKept: "financials-hero-kept",
        kpiGrid: "financials-kpi-grid",
        kpiStoryCard: (k) => `financials-kpi-${k}-card`,
        kpiDelta: (k) => `financials-kpi-${k}-delta`,
        leaderboard: "financials-branch-leaderboard",
        leaderboardRow: (id) => `financials-branch-row-button-${id}`,
        expenseDest: "financials-expenses-destination",
        expenseDestRow: (k) => `financials-expenses-dest-row-${k}`,
        commissionBadge: "financials-expenses-commission-badge",
        profitTrend: "financials-profit-trend",
        ramadanBadge: "financials-profit-trend-ramadan-badge",
        insights: "financials-insights",
        insightItem: (k) => `financials-insight-${k}`,
        detailsExpander: "financials-details-expander-trigger",
    },
    finAnalytics: {
        hub: "financials-hub",
        hubTab: (k) => `financials-hub-tab-${k}`,
        page: "financial-analytics-page",
        periodLabel: "financial-analytics-period",
        emptyState: "financial-analytics-empty-state",
        errorState: "financial-analytics-error-state",
        retry: "financial-analytics-retry-button",
        kpiGrid: "financial-analytics-kpi-grid",
        kpiCard: (k) => `financial-analytics-kpi-${k}`,
        metricsStrip: "financial-analytics-metrics-strip",
        metricCard: (k) => `financial-analytics-metric-${k}`,
        expenseCard: "financial-analytics-expense-breakdown",
        expenseChart: "financial-analytics-expense-chart",
        expenseRow: (k) => `financial-analytics-expense-row-${k}`,
        cashCard: "financial-analytics-cash",
        cashTotal: "financial-analytics-cash-total",
        cashList: "financial-analytics-cash-list",
        cashRow: (k) => `financial-analytics-cash-row-${k}`,
        receivablesCard: "financial-analytics-receivables",
        receivablesTotal: "financial-analytics-receivables-total",
        agingChart: "financial-analytics-aging-chart",
        debtorsList: "financial-analytics-debtors-list",
        debtorRow: (k) => `financial-analytics-debtor-row-${k}`,
        fcvCard: "financial-analytics-food-variance",
        fcvCompanyPct: "financial-analytics-fcv-company-pct",
        fcvBaseline: "financial-analytics-fcv-baseline",
        fcvTable: "financial-analytics-fcv-table",
        fcvRow: (k) => `financial-analytics-fcv-row-${k}`,
        fcvNote: "financial-analytics-fcv-note",
    },
    ccMap: {
        openBtn: "financials-cc-map-button",
        dialog: "cc-map-dialog",
        table: "cc-map-table",
        row: (k) => `cc-map-row-${k}`,
        select: (k) => `cc-map-select-${k}`,
        status: (k) => `cc-map-status-${k}`,
    },
    erpPl: {
        importBtn: "financials-erp-import-button",
        dialog: "erp-pl-dialog",
        file: "erp-pl-file-input",
        upload: "erp-pl-upload-button",
        result: "erp-pl-result",
        error: "erp-pl-error",
        month: "erp-pl-month",
        stat: (k) => `erp-pl-stat-${k}`,
        unmapped: "erp-pl-unmapped",
        ccRow: (k) => `erp-pl-cc-row-${k}`,
    },
    finImporter: {
        dialog: "financials-import-dialog",
        file: "financials-import-file-input",
        upload: "financials-import-upload-button",
        token: "financials-import-service-token",
        copy: "financials-import-copy-token",
        result: "financials-import-result",
    },
    branches: {
        page: "branches-page",
        table: "branches-table",
        row: (id) => `branches-row-${id}`,
        add: "branches-add-button",
        rename: (id) => `branches-rename-action-${id}`,
        toggle: (id) => `branches-toggle-active-action-${id}`,
        posId: (id) => `branches-pos-id-${id}`,
        hrId: (id) => `branches-hr-id-${id}`,
        hrTestBtn: (id) => `branches-hr-test-btn-${id}`,
        hrTestResult: (id) => `branches-hr-test-result-${id}`,
        financeOnlyBadge: (id) => `branches-finance-only-badge-${id}`,
        // the branch's own operations manager «مدير العمليات للفرع» (2026-11-01)
        opsManager: (id) => `branches-ops-manager-${id}`,
        form: {
            nameAr: "branch-form-name-ar",
            nameEn: "branch-form-name-en",
            code: "branch-form-code",
            posId: "branch-form-pos-id",
            hrId: "branch-form-hr-id",
            financeOnly: "branch-form-finance-only",
            posWarning: "branch-form-pos-warning",
            opsManager: "branch-form-ops-manager",
            opsManagerOption: (id) => `branch-form-ops-manager-option-${id}`,
            save: "branch-form-save",
        },
        clearConfirm: "branches-clear-links-confirm",
        clearConfirmSave: "branches-clear-links-save",
        deactivate: {
            dialog: "branches-deactivate-dialog",
            input: "branches-deactivate-name-input",
            confirm: "branches-deactivate-confirm",
        },
    },
    error: { e401: "error-401", e403: "error-403", loading: "global-loading", noAccess: "no-access" },
    callCenter: {
        page: "call-center-page",
        rangeFrom: "call-center-range-from",
        rangeTo: "call-center-range-to",
        preset: (k) => `call-center-preset-${k}`,
        kpi: "call-center-kpi-section",
        kpiCard: (k) => `call-center-kpi-${k}`,
        revenueNote: "call-center-revenue-note",
        deliveryPanel: "call-center-delivery-panel",
        deliveryWarning: "call-center-delivery-warning",
        unpaidFlag: "call-center-unpaid-flag",
        branchTable: "call-center-branch-table",
        branchRow: (id) => `call-center-branch-row-${id}`,
        agentTable: "call-center-agent-table",
        agentRow: (k) => `call-center-agent-row-${k}`,
        agentCount: "call-center-agent-count",
        agentSort: (c) => `call-center-agent-sort-${c}`,
        empty: "call-center-empty-state",
        errorState: "call-center-error-state",
        retry: "call-center-retry-button",
        loading: "call-center-loading",
    },
    salesSync: {
        page: "sales-sync-page",
        modeTabs: "sales-sync-mode-tabs",
        modeYesterday: "sales-sync-mode-yesterday",
        modeRange: "sales-sync-mode-range",
        fromDate: "sales-sync-from-date",
        toDate: "sales-sync-to-date",
        start: "sales-sync-start-button",
        stop: "sales-sync-stop-button",
        retry: "sales-sync-retry-button",
        progress: "sales-sync-progress",
        progressBar: "sales-sync-progress-bar",
        summary: "sales-sync-summary",
        summaryCard: (k) => `sales-sync-summary-${k}`,
        log: "sales-sync-log",
        logRow: (k) => `sales-sync-log-row-${k}`,
        corsBanner: "sales-sync-cors-banner",
        idle: "sales-sync-idle-state",
        incrementalToggle: "sales-sync-incremental-toggle",
        configBanner: "sales-sync-config-banner",
        coverage: "sales-sync-coverage",
        coverageRow: (d) => `sales-sync-coverage-row-${d}`,
        failures: "sales-sync-failures",
        currentInfo: "sales-sync-current-info",
        datasetTabs: "sales-sync-dataset-tabs",
        dataset: (k) => `sales-sync-dataset-${k}`,
        masters: "sales-sync-masters",
        history: "sales-sync-history-card",
        historyState: "sales-sync-history-state",
        historyBar: "sales-sync-history-bar",
        historyResume: "sales-sync-history-resume-button",
        historyOtherRun: "sales-sync-history-other-run",
        readOnly: "sales-sync-read-only-note",
    },
    cashierCheckPage: "cashier-check-page",
    posInsights: {
        page: "pos-insights-page",
        preset: (k) => `pos-insights-preset-${k}`,
        fromDate: "pos-insights-from-date",
        toDate: "pos-insights-to-date",
        branchFilter: "pos-insights-branch-filter",
        refresh: "pos-insights-refresh",
        kpi: "pos-insights-kpi-row",
        kpiCard: (k) => `pos-insights-kpi-${k}`,
        tab: (k) => `pos-insights-tab-${k}`,
        hourlyChart: "pos-insights-hourly-chart",
        heatmap: "pos-insights-heatmap",
        heatCell: (b, h) => `pos-insights-heat-${b}-${h}`,
        trendChart: "pos-insights-trend-chart",
        itemsTable: "pos-insights-items-table",
        itemRow: (id) => `pos-insights-item-row-${id}`,
        itemsSearch: "pos-insights-items-search",
        itemsSort: "pos-insights-items-sort",
        catsMenu: "pos-insights-menu-categories",
        catsRecipe: "pos-insights-recipe-categories",
        appsTable: "pos-insights-apps-table",
        orderTypes: "pos-insights-order-types",
        payments: "pos-insights-payments",
        payStates: "pos-insights-pay-states",
        cashiers: "pos-insights-cashiers",
        cashierCheck: "pos-insights-cashier-check",
        ccPeriod: "pos-insights-cc-period",
        ccBase: "pos-insights-cc-base",
        ccExport: "pos-insights-cc-export",
        ccEmpty: "pos-insights-cc-empty",
        ccBranch: (pos) => `pos-insights-cc-branch-${pos}`,
        ccMissing: (pos) => `pos-insights-cc-missing-${pos}`,
        ccBackfill: "pos-insights-cc-backfill",
        ccBranchFilter: "pos-insights-cc-branch-filter",
        ccDaily: "pos-insights-cc-daily",
        ccDailyFile: (day) => `pos-insights-cc-daily-${day}`,
        ccDailyMore: "pos-insights-cc-daily-more",
        ccRow: (pos, i) => `pos-insights-cc-row-${pos}-${i}`,
        terminals: "pos-insights-terminals",
        deliveryMen: "pos-insights-delivery-men",
        coverage: "pos-insights-coverage",
        recon: "pos-insights-recon",
        mastersCard: "pos-insights-masters",
        masterRow: (k) => `pos-insights-master-${k}`,
        capabilities: "pos-insights-capabilities",
        branchTable: "pos-insights-branch-table",
        branchRow: (id) => `pos-insights-branch-row-${id}`,
        empty: "pos-insights-empty",
        loading: "pos-insights-loading",
    },
    backups: {
        page: "backups-page",
        card: "backups-card",
        runNow: "backups-run-now",
        runningBadge: "backups-running-badge",
        table: "backups-table",
        row: (folder) => `backups-row-${folder}`,
        rowStatus: (folder) => `backups-row-status-${folder}`,
        empty: "backups-empty",
        errorBanner: "backups-error-banner",
        summary: "backups-summary",
        confirm: "backups-confirm-dialog",
        confirmStart: "backups-confirm-start",
    },
    hrIntegration: {
        page: "hr-integration-page",
        stat: (k) => `hr-ev-stat-${k}`,
        sendNow: "hr-ev-send-now",
        sendConfirm: "hr-ev-send-confirm",
        sendConfirmStart: "hr-ev-send-confirm-start",
        reconcile: "hr-ev-reconcile",
        reconcileConfirm: "hr-ev-reconcile-confirm",
        reconcileConfirmStart: "hr-ev-reconcile-confirm-start",
        lastChecked: "hr-ev-last-checked",
        errors: "hr-ev-errors",
        clips: "hr-ev-clips",
        over25: (k) => `hr-ev-over25-${k}`,
        notConfigured: "hr-ev-not-configured",
        health: "hr-ev-health",
    },
    dataAudit: {
        page: "data-audit-page",
        monthSelect: "data-audit-month",
        refresh: "data-audit-refresh",
        summary: "data-audit-summary",
        stat: (k) => `data-audit-stat-${k}`,
        frontier: "data-audit-frontier",
        tab: (k) => `data-audit-tab-${k}`,
        tabLoading: (k) => `data-audit-tab-loading-${k}`,
        cardRow: (p, c) => `data-audit-card-${p}-${c}`,
        cardFix: (p, c) => `data-audit-card-fix-${p}-${c}`,
        checkRow: (k) => `data-audit-check-${k}`,
        coverage: "data-audit-coverage",
        covCell: (ds, m) => `data-audit-cov-${ds}-${m}`,
        noAnomalies: "data-audit-no-anomalies",
        anomalyRow: (k) => `data-audit-anomaly-${k}`,
        anomalyFix: (k) => `data-audit-anomaly-fix-${k}`,
        fixDialog: "data-audit-fix-dialog",
        fixCount: "data-audit-fix-count",
        fixSample: "data-audit-fix-sample",
        fixConfirm: "data-audit-fix-confirm",
    },
    qc: {
        page: "qc-waste-page",
        branchSelect: "qc-branch-select",
        datePicker: "qc-visit-date-trigger",
        calendar: "qc-visit-date-calendar",
        pastVisits: "qc-past-visits-select",
        readingsTable: "qc-readings-table",
        received: (k) => `qc-received-${k}`,
        weighed: (k) => `qc-weighed-${k}`,
        save: "qc-save-visit-button",
        result: "qc-result-panel",
        resultBaseline: "qc-result-baseline",
        resultTable: "qc-result-table",
        resultRow: (k) => `qc-result-row-${k}`,
        periodLabel: "qc-period-label",
        gapsWarning: "qc-data-gaps-warning",
        summary: "qc-summary",
        summaryCard: (k) => `qc-summary-${k}`,
        emptyState: "qc-result-empty",
    },
    wm: {
        hub: "wm-hub",
        tab: (k) => `wm-hub-tab-${k}`,
        noHomeBranch: "wm-no-home-branch",
        adminOnlyNote: "wm-admin-only-note",
        branchSelect: "wm-branch-select",
        branchOption: (id) => `wm-branch-option-${id}`,
        dateInput: "wm-date-input",
        dateInputTop: "wm-date-input-top",
        noActivityBlocked: "wm-no-activity-blocked",
        moreToggle: "wm-more-toggle",
        modeQuick: "wm-mode-quick",
        modeSheet: "wm-mode-sheet",
        offlineError: "wm-offline-error",
        retry: "wm-retry-btn",
        quick: {
            form: "wm-quick-form",
            qty: "wm-quick-qty",
            reason: "wm-quick-reason",
            notes: "wm-quick-notes",
            save: "wm-quick-save",
        },
        picker: {
            trigger: "wm-item-picker-trigger",
            dialog: "wm-item-picker",
            search: "wm-item-picker-search",
            option: (id) => `wm-item-option-${id}`,
            requestLink: "wm-item-request-link",
            empty: "wm-item-picker-empty",
            // 2026-10-16 (D2): raw-ingredient items carry a «خام» badge
            rawBadge: (id) => `wm-item-option-raw-${id}`,
        },
        itemRequest: {
            dialog: "wm-item-request-dialog",
            text: "wm-item-request-text",
            note: "wm-item-request-note",
            submit: "wm-item-request-submit",
        },
        sheet: {
            form: "wm-day-sheet",
            line: (id) => `wm-sheet-line-${id}`,
            qty: (id) => `wm-sheet-qty-${id}`,
            reason: (id) => `wm-sheet-reason-${id}`,
            chip: (id) => `wm-sheet-chip-${id}`,
            defaultReason: "wm-sheet-default-reason",
            save: "wm-sheet-save",
            count: "wm-sheet-count",
            fallbackNote: "wm-sheet-fallback-note",
            // 2026-10-16 (D2 / A1): raw badge + the per-line note
            rawBadge: (id) => `wm-sheet-raw-${id}`,
            noteToggle: (id) => `wm-sheet-note-toggle-${id}`,
            note: (id) => `wm-sheet-note-${id}`,
            notePreview: (id) => `wm-sheet-note-preview-${id}`,
            noteNeedsQty: (id) => `wm-sheet-note-needs-qty-${id}`,
            reasonNotWaste: (id) => `wm-sheet-reason-not-waste-${id}`,
        },
        noActivity: "wm-no-activity-btn",
        noActivityUndo: "wm-no-activity-undo",
        noActivityUndoDialog: "wm-no-activity-undo-dialog",
        noActivityUndoReason: "wm-no-activity-undo-reason",
        noActivityUndoConfirm: "wm-no-activity-undo-confirm",
        noActivityUndoCancel: "wm-no-activity-undo-cancel",
        beneficiaries: "wm-beneficiaries-input",
        beneficiariesSave: "wm-beneficiaries-save",
        myEntries: {
            list: "wm-my-entries",
            row: (id) => `wm-my-entry-${id}`,
            edit: (id) => `wm-my-entry-edit-${id}`,
            del: (id) => `wm-my-entry-delete-${id}`,
            empty: "wm-my-entries-empty",
            returnBadge: (id) => `wm-my-entry-return-badge-${id}`,
        },
        panel: {
            dialog: "wm-record-panel",
            row: (id) => `wm-panel-row-${id}`,
            edit: (id) => `wm-panel-edit-${id}`,
            del: (id) => `wm-panel-delete-${id}`,
            hidden: "wm-panel-hidden-note",
            empty: "wm-panel-empty",
            // 2026-10-16 (D2): a «مرتجع للمستودع» record, which no total counts
            returnBadge: (id) => `wm-panel-return-badge-${id}`,
        },
        editDialog: {
            dialog: "wm-edit-dialog",
            qty: "wm-edit-qty",
            reason: "wm-edit-reason",
            notes: "wm-edit-notes",
            save: "wm-edit-save",
        },
        grid: {
            table: "wm-grid",
            month: "wm-grid-month",
            row: (id) => `wm-grid-row-${id}`,
            cell: (id, d) => `wm-grid-cell-${id}-${d}`,
            total: (id) => `wm-grid-total-${id}`,
            dayTotal: (d) => `wm-grid-day-total-${d}`,
            monthTotal: "wm-grid-month-total",
            scopeBadge: "wm-grid-scope-badge",
            beneficiaries: (d) => `wm-grid-beneficiaries-${d}`,
            empty: "wm-grid-empty",
            // 2026-10-16 (D2 returns · D5 cost · A3 export)
            returnsTable: "wm-grid-returns",
            returnsRow: (id) => `wm-grid-returns-row-${id}`,
            returnsCell: (id, d) => `wm-grid-returns-cell-${id}-${d}`,
            returnsTotal: (id) => `wm-grid-returns-total-${id}`,
            returnsMonthTotal: "wm-grid-returns-month-total",
            cost: (id) => `wm-grid-cost-${id}`,
            missingCost: (id) => `wm-grid-missing-cost-${id}`,
            monthCost: "wm-grid-month-cost",
            wastePct: "wm-grid-waste-pct",
            exportBtn: "wm-grid-export",
            exportDialog: "wm-grid-export-dialog",
            exportScope: "wm-grid-export-scope",
            exportScopeOption: (k) => `wm-grid-export-scope-${k}`,
            exportType: (k) => `wm-grid-export-type-${k}`,
            exportRun: "wm-grid-export-run",
        },
        coverage: {
            table: "wm-coverage",
            date: "wm-coverage-date",
            row: (id) => `wm-coverage-row-${id}`,
            state: (id) => `wm-coverage-state-${id}`,
            empty: "wm-coverage-empty",
            returns: (id) => `wm-coverage-returns-${id}`,
        },
        admin: {
            tab: "wm-admin",
            section: (k) => `wm-admin-section-${k}`,
            requestsBadge: "wm-admin-requests-badge",
            itemSearch: "wm-admin-item-search",
            usageFilter: (u) => `wm-admin-usage-filter-${u}`,
            onlyActive: "wm-admin-only-active",
            itemAdd: "wm-admin-item-add",
            itemsTable: "wm-admin-items-table",
            itemsEmpty: "wm-admin-items-empty",
            itemRow: (id) => `wm-admin-item-row-${id}`,
            itemState: (id) => `wm-admin-item-state-${id}`,
            itemEdit: (id) => `wm-admin-item-edit-${id}`,
            itemDialog: "wm-admin-item-dialog",
            itemNameAr: "wm-admin-item-name-ar",
            itemNameEn: "wm-admin-item-name-en",
            itemUsage: "wm-admin-item-usage",
            itemUsageOption: (u) => `wm-admin-item-usage-${u}`,
            itemUnit: "wm-admin-item-unit",
            itemUnitOption: (k) => `wm-admin-item-unit-${k}`,
            itemUnitLocked: "wm-admin-item-unit-locked",
            itemCategory: "wm-admin-item-category",
            itemActive: "wm-admin-item-active",
            itemSave: "wm-admin-item-save",
            itemCancel: "wm-admin-item-cancel",
            unitKey: "wm-admin-unit-key",
            unitNameAr: "wm-admin-unit-name-ar",
            unitNameEn: "wm-admin-unit-name-en",
            unitDecimal: "wm-admin-unit-decimal",
            unitAdd: "wm-admin-unit-add",
            unitsTable: "wm-admin-units-table",
            unitRow: (k) => `wm-admin-unit-row-${k}`,
            unitToggle: (k) => `wm-admin-unit-toggle-${k}`,
            reasonKey: "wm-admin-reason-key",
            reasonNameAr: "wm-admin-reason-name-ar",
            reasonNameEn: "wm-admin-reason-name-en",
            reasonAdd: "wm-admin-reason-add",
            reasonsTable: "wm-admin-reasons-table",
            reasonRow: (k) => `wm-admin-reason-row-${k}`,
            reasonToggle: (k) => `wm-admin-reason-toggle-${k}`,
            requestFilter: (s) => `wm-admin-request-filter-${s}`,
            requestsEmpty: "wm-admin-requests-empty",
            requestRow: (id) => `wm-admin-request-row-${id}`,
            requestStatus: (id) => `wm-admin-request-status-${id}`,
            requestItemSelect: (id) => `wm-admin-request-item-${id}`,
            requestItemOption: (rid, iid) => `wm-admin-request-item-${rid}-${iid}`,
            requestResolve: (id) => `wm-admin-request-resolve-${id}`,
            requestReject: (id) => `wm-admin-request-reject-${id}`,
            policyCard: "wm-admin-policy",
            policyReasonRequired: "wm-admin-policy-reason-required",
            policyField: (k) => `wm-admin-policy-${k}`,
            policySave: "wm-admin-policy-save",
            // 2026-10-16 (D2): reasons that are NOT a loss, raw items
            reasonCountsAsWaste: (k) => `wm-admin-reason-counts-${k}`,
            reasonNewCountsAsWaste: "wm-admin-reason-new-counts",
            reasonLocked: (k) => `wm-admin-reason-locked-${k}`,
            itemKind: "wm-admin-item-kind",
            itemKindOption: (k) => `wm-admin-item-kind-${k}`,
            itemScCode: "wm-admin-item-sc-code",
            itemIngredientKey: "wm-admin-item-ingredient-key",
            itemRawBadge: (id) => `wm-admin-item-raw-${id}`,
            // 2026-10-16 (D5): «ربط الوصفات» and «تكلفة ناقصة»
            linksTable: "wm-admin-links",
            linksSummary: "wm-admin-links-summary",
            linksEmpty: "wm-admin-links-empty",
            linkSearch: "wm-admin-links-search",
            linkFilter: (k) => `wm-admin-links-filter-${k}`,
            linkConfirmAll: "wm-admin-links-confirm-all",
            linkConfirmAllDialog: "wm-admin-links-confirm-all-dialog",
            linkConfirmAllRun: "wm-admin-links-confirm-all-run",
            linkRow: (id) => `wm-admin-link-row-${id}`,
            linkConfidence: (id) => `wm-admin-link-confidence-${id}`,
            linkRecipe: (id) => `wm-admin-link-recipe-${id}`,
            linkFactor: (id) => `wm-admin-link-factor-${id}`,
            linkConfirm: (id) => `wm-admin-link-confirm-${id}`,
            linkUnlink: (id) => `wm-admin-link-unlink-${id}`,
            linkCost: (id) => `wm-admin-link-cost-${id}`,
            recipePicker: "wm-admin-recipe-picker",
            recipePickerSearch: "wm-admin-recipe-picker-search",
            recipePickerEmpty: "wm-admin-recipe-picker-empty",
            recipeOption: (k) => `wm-admin-recipe-option-${k}`,
            missingCost: "wm-admin-missing-cost",
            missingAllClear: "wm-admin-missing-all-clear",
            missingGroup: (k) => `wm-admin-missing-group-${k}`,
            missingRow: (k, id) => `wm-admin-missing-row-${k}-${id}`,
        },
    },
    // Branch hub shell «عمليات الفرع» + Cancellations «إلغاء الطلبات» (CP3)
    hub: {
        shell: "branch-ops-hub",
        sectionSwitch: "branch-ops-section-switch",
        section: (k) => `branch-ops-section-${k}`,
        sectionPanel: (k) => `branch-ops-section-panel-${k}`,
    },
    branchOps: {
        hub: "branch-ops-hub",
        sectionSwitch: "branch-ops-sections",
        section: (k) => `branch-ops-section-${k}`,
    },
    co: {
        section: "co-section",
        tab: (k) => `co-tab-${k}`,
        notReady: "co-not-ready",
        noHomeBranch: "co-no-home-branch",
        comingSoon: (k) => `co-coming-soon-${k}`,
        branchSelect: "co-branch-select",
        branchOption: (id) => `co-branch-option-${id}`,
        form: "co-form",
        photo: {
            input: "co-photo-input",
            button: "co-photo-btn",
            preview: "co-photo-preview",
            status: "co-photo-status",
            retake: "co-photo-retake",
            warning: "co-photo-warning",        // data-kind: not_kept | failed | lost
            retry: "co-photo-retry",
        },
        photoBlocked: "co-photo-blocked",
        invoice: "co-invoice",
        invoiceHelper: "co-invoice-helper",
        posLookup: "co-pos-lookup-btn",
        posResult: "co-pos-result",
        customerHeading: "co-customer-heading",
        value: "co-value",
        valueWarn: "co-value-warn",
        valueConfirm: "co-value-confirm",
        outcome: (k) => `co-outcome-${k}`,
        phoneKind: (k) => `co-phone-kind-${k}`,
        phone: "co-phone",
        source: (k) => `co-source-${k}`,
        sourceLocked: "co-source-locked",
        category: (k) => `co-category-${k}`,
        categoryMore: "co-category-more",
        reason: "co-reason",
        moreToggle: "co-more-toggle",
        outcomeNote: "co-outcome-note",
        reissued: "co-reissued",
        date: "co-date",
        time: "co-time",
        save: "co-save",
        cancelEdit: "co-cancel-edit",
        offlineError: "co-offline-error",
        retry: "co-retry-btn",
        duplicate: {
            card: "co-duplicate-card",
            confirm: "co-duplicate-confirm",
            cancel: "co-duplicate-cancel",
        },
        confirmation: "co-confirmation",
        mine: {
            list: "co-my-entries",
            row: (id) => `co-my-row-${id}`,
            photoStatus: (id) => `co-my-photo-status-${id}`,
            posStatus: (id) => `co-my-pos-status-${id}`,
            edit: (id) => `co-my-edit-${id}`,
            del: (id) => `co-my-delete-${id}`,
            viewPhoto: (id) => `co-my-photo-view-${id}`,
            retake: (id) => `co-my-photo-retake-${id}`,
            photoDialog: "co-my-photo-dialog",
            photoImg: "co-my-photo-img",
            photoError: "co-my-photo-error",
            empty: "co-my-entries-empty",
            total: "co-my-entries-total",
        },
        // CP6-lite: «السجلات» (p = "co-records") and «يحتاج مراجعة» (p = "co-review") share one list
        records: (p) => ({
            view: `${p}-view`,
            dateFrom: `${p}-date-from`,
            dateTo: `${p}-date-to`,
            branch: `${p}-filter-branch`,
            filtersToggle: `${p}-filters-toggle`,
            filter: (k) => `${p}-filter-${k}`,
            option: (k, v) => `${p}-filter-${k}-${v}`,
            duplicates: `${p}-show-duplicates`,
            reset: `${p}-reset`,
            totals: `${p}-totals`,
            totalCount: `${p}-total-count`,
            totalValue: `${p}-total-value`,
            totalStill: `${p}-total-still`,
            exportBtn: `${p}-export`,
            list: `${p}-list`,
            row: (id) => `${p}-row-${id}`,
            rowFlags: (id) => `${p}-row-flags-${id}`,
            rowReview: (id) => `${p}-row-review-${id}`,
            empty: `${p}-empty`,
            pageInfo: `${p}-page-info`,
            prev: `${p}-prev`,
            next: `${p}-next`,
        }),
        panel: {
            sheet: "co-panel",
            close: "co-panel-close",
            field: (k) => `co-panel-field-${k}`,
            photo: "co-panel-photo",
            photoMissing: "co-panel-photo-missing",
            photoBroken: "co-panel-photo-broken",
            photoDiag: "co-panel-photo-diag",
            pos: "co-panel-pos",
            flags: "co-panel-flags",
            managerNote: "co-panel-manager-note",
            managerNoteSave: "co-panel-manager-note-save",
            review: "co-panel-review",
            reviewStatus: (k) => `co-panel-review-status-${k}`,
            reviewNote: "co-panel-review-note",
            reviewSave: "co-panel-review-save",
            reviewCurrent: "co-panel-review-current",
            dismissDuplicate: "co-panel-dismiss-duplicate",
            audit: "co-panel-audit",
            auditRow: (id) => `co-panel-audit-row-${id}`,
            del: "co-panel-delete",
            delDialog: "co-panel-delete-dialog",
            delReason: "co-panel-delete-reason",
            delConfirm: "co-panel-delete-confirm",
            delCancel: "co-panel-delete-cancel",
        },
    },
    // Monthly stock count «الجرد الشهري» (hub section `sc`). Shared by every
    // stock-count component; see memory/stock-count/SPEC.md §7.
    sc: {
        section: "sc-section",
        tab: (k) => `sc-tab-${k}`,
        note: "sc-note",
        locationSelect: "sc-location-select",
        locationOption: (id) => `sc-location-option-${id}`,
        periodSelect: "sc-period-select",
        windowBanner: "sc-window-banner",
        reopened: "sc-reopened",
        reopenedOpen: (loc, p) => `sc-reopened-open-${loc}-${p}`,
        statusChip: "sc-status-chip",
        offlineError: "sc-offline-error",
        retry: "sc-retry-btn",
        sheet: {
            form: "sc-sheet",
            search: "sc-sheet-search",
            group: (i) => `sc-group-${i}`,
            uncounted: "sc-filter-uncounted",
            line: (id) => `sc-line-${id}`,
            qty: (id) => `sc-qty-${id}`,
            packs: (id) => `sc-packs-${id}`,
            loose: (id) => `sc-loose-${id}`,
            lineValue: (id) => `sc-line-value-${id}`,
            lineError: (id) => `sc-line-error-${id}`,
            progress: "sc-sheet-progress",
            total: "sc-sheet-total",
            dirty: "sc-sheet-dirty",
            save: "sc-sheet-save",
            submit: "sc-sheet-submit",
        },
        submitDialog: {
            dialog: "sc-submit-dialog",
            missing: "sc-submit-missing",
            zeroFill: "sc-submit-zero-fill",
            confirm: "sc-submit-confirm",
            cancel: "sc-submit-cancel",
        },
        board: {
            view: "sc-board",
            period: "sc-board-period",
            kind: "sc-board-kind",
            totals: "sc-board-totals",
            total: (k) => `sc-board-total-${k}`,
            row: (id) => `sc-board-row-${id}`,
            cell: (id, k) => `sc-board-cell-${id}-${k}`,
            empty: "sc-board-empty",
            exportBtn: "sc-board-export",
        },
        panel: {
            sheet: "sc-panel",
            close: "sc-panel-close",
            line: (id) => `sc-panel-line-${id}`,
            total: "sc-panel-total",
            approve: "sc-panel-approve",
            unapprove: "sc-panel-unapprove",
            reopen: "sc-panel-reopen",
            edit: "sc-panel-edit",
            history: "sc-panel-history",
        },
        reopenDialog: {
            dialog: "sc-reopen-dialog",
            reason: "sc-reopen-reason",
            until: "sc-reopen-until",
            confirm: "sc-reopen-confirm",
            cancel: "sc-reopen-cancel",
        },
        reasonDialog: {
            dialog: "sc-reason-dialog",
            reason: "sc-reason-text",
            confirm: "sc-reason-confirm",
            cancel: "sc-reason-cancel",
        },
        items: {
            view: "sc-items",
            search: "sc-items-search",
            group: "sc-items-group",
            showInactive: "sc-items-inactive",
            add: "sc-items-add",
            row: (id) => `sc-items-row-${id}`,
            edit: (id) => `sc-items-edit-${id}`,
            empty: "sc-items-empty",
        },
        itemDialog: {
            dialog: "sc-item-dialog",
            field: (k) => `sc-item-field-${k}`,
            kind: (k) => `sc-item-kind-${k}`,
            save: "sc-item-save",
            cancel: "sc-item-cancel",
        },
        costs: {
            view: "sc-costs",
            upload: "sc-costs-upload",
            sets: "sc-costs-sets",
            set: (id) => `sc-costs-set-${id}`,
            deactivate: (id) => `sc-costs-set-off-${id}`,
            deactivateConfirm: "sc-costs-set-off-confirm",
            deactivateCancel: "sc-costs-set-off-cancel",
            period: "sc-costs-period",
            missing: "sc-costs-missing",
        },
        uploadDialog: {
            dialog: "sc-upload-dialog",
            drop: "sc-upload-drop",
            input: "sc-upload-input",
            file: (i) => `sc-upload-file-${i}`,
            remove: (i) => `sc-upload-remove-${i}`,
            result: "sc-upload-result",
            commit: "sc-upload-commit",
            cancel: "sc-upload-cancel",
        },
        setup: {
            view: "sc-setup",
            location: (id) => `sc-setup-location-${id}`,
            locationActive: (id) => `sc-setup-location-active-${id}`,
            locationStore: (id) => `sc-setup-location-store-${id}`,
            setting: (k) => `sc-setup-setting-${k}`,
            save: "sc-setup-save",
        },
    },
    // Daily key-item count «الجرد اليومي» (hub section `dk`). Shared by every
    // daily-count component; see memory/sheet-retirement/SPEC.md §4.
    dk: {
        section: "dk-section",
        tab: (k) => `dk-tab-${k}`,
        note: "dk-note",
        retry: "dk-retry-btn",
        offlineError: "dk-offline-error",
        locationSelect: "dk-location-select",
        locationOption: (id) => `dk-location-option-${id}`,
        dateInput: "dk-date-input",
        dateChip: (k) => `dk-date-chip-${k}`,
        monthSelect: "dk-month-select",
        day: {
            form: "dk-day",
            editReason: "dk-day-edit-reason",
            dataState: "dk-day-data-state",
            coverage: "dk-day-coverage",
            card: (id) => `dk-card-${id}`,
            opening: (id) => `dk-opening-${id}`,
            openingOverride: (id) => `dk-opening-override-${id}`,
            received: (id) => `dk-received-${id}`,
            receivedPacks: (id) => `dk-received-packs-${id}`,
            receivedLoose: (id) => `dk-received-loose-${id}`,
            more: (id) => `dk-more-${id}`,
            sent: (id) => `dk-sent-${id}`,
            sentTo: (id) => `dk-sent-to-${id}`,
            closing: (id) => `dk-closing-${id}`,
            closingPacks: (id) => `dk-closing-packs-${id}`,
            closingLoose: (id) => `dk-closing-loose-${id}`,
            note: (id) => `dk-line-note-${id}`,
            used: (id) => `dk-used-${id}`,
            theo: (id) => `dk-theo-${id}`,
            variance: (id) => `dk-variance-${id}`,
            flag: (id) => `dk-flag-${id}`,
            warn: (id) => `dk-warn-${id}`,
            lineError: (id) => `dk-line-error-${id}`,
            progress: "dk-day-progress",
            flagsN: "dk-day-flags",
            save: "dk-day-save",
            dirty: "dk-day-dirty",
        },
        overrideDialog: {
            dialog: "dk-override-dialog",
            value: "dk-override-value",
            reason: "dk-override-reason",
            confirm: "dk-override-confirm",
            clear: "dk-override-clear",
            cancel: "dk-override-cancel",
        },
        month: {
            view: "dk-month",
            grid: "dk-month-grid",
            mode: "dk-month-mode",
            modeOption: (m) => `dk-month-mode-${m}`,
            row: (item) => `dk-month-row-${item}`,
            cell: (item, date) => `dk-month-cell-${item}-${date}`,
            total: (item) => `dk-month-total-${item}`,
            empty: "dk-month-empty",
        },
        dayPanel: {
            sheet: "dk-day-panel",
            line: (id) => `dk-day-panel-line-${id}`,
            openDay: "dk-day-panel-open-day",
            close: "dk-day-panel-close",
        },
        variance: {
            view: "dk-variance",
            board: "dk-variance-board",
            range: "dk-variance-range",
            rangeMode: (m) => `dk-variance-range-${m}`,
            dateFrom: "dk-variance-from",
            dateTo: "dk-variance-to",
            cell: (loc, item) => `dk-variance-cell-${loc}-${item}`,
            flagsN: "dk-variance-flags",
            empty: "dk-variance-empty",
            exportBtn: "dk-variance-export",
        },
        reconcile: {
            view: "dk-reconcile",
            table: "dk-reconcile-table",
            row: (loc, item) => `dk-reconcile-row-${loc}-${item}`,
            sar: (loc, item) => `dk-reconcile-sar-${loc}-${item}`,
            sarTotal: "dk-reconcile-sar-total",
            empty: "dk-reconcile-empty",
            exportBtn: "dk-reconcile-export",
        },
        items: {
            view: "dk-items",
            row: (id) => `dk-items-row-${id}`,
            edit: (id) => `dk-items-edit-${id}`,
            empty: "dk-items-empty",
            dialog: "dk-item-dialog",
            field: (k) => `dk-item-field-${k}`,
            keySearch: "dk-item-key-search",
            keys: "dk-item-keys",
            keyOption: (k) => `dk-item-key-${k}`,
            excluded: (code) => `dk-item-excluded-${code}`,
            save: "dk-item-save",
            cancel: "dk-item-cancel",
        },
        setup: {
            view: "dk-setup",
            field: (k) => `dk-setup-field-${k}`,
            locationCode: (code) => `dk-setup-location-${code}`,
            save: "dk-setup-save",
        },
        userLocationsHint: "user-form-dk-locations-hint",
    },
};
